import mobileImage from '../../../images/telegram-banner/mobile.png';
import desktopLeftImage from '../../../images/telegram-banner/desktop-left.png';
import desktopRightImage from '../../../images/telegram-banner/desktop-right.png';
import { TELEGRAM_CHANNEL_URL } from '../../../constants';
import { MetrikaGoal } from '../../../hooks';

import { Banner } from '../Banner';

const STORAGE_KEY = 'telegramBannerClosed';

export const TelegramBanner = () => (
    <Banner
        storageKey={STORAGE_KEY}
        text="Мы завели Telegram-канал, чтобы делиться новостями"
        buttonText="Открыть"
        url={TELEGRAM_CHANNEL_URL}
        metrikaGoal={MetrikaGoal.ClickTelegram}
        images={{
            mobileLeft: mobileImage,
            desktopLeft: desktopLeftImage,
            desktopRight: desktopRightImage,
        }}
    />
);
